module.exports = __webpack_public_path__ + "static/clickup-9eaf1fa535527fbec15e3b43e8b30819.svg";